import React from "react";
import { useState, useEffect } from "react";

import "./Footer.css"; // import custom CSS file for styling

const Footer = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // ✅ Example: Adjust login check as per your app
    const token = localStorage.getItem("homeshiksha-jwt");
    setIsLoggedIn(!!token);
  }, []);

  if (!!isLoggedIn) {
    console.log("🚀 ~ Footer ~ isLoggedIn:", isLoggedIn);
    return <></>;
  }

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* <div className="footer-section">
          <h4>Tutor by City</h4>
          <ul>
            <li>Hyderabad</li>
            <li>Dehradun</li>
            <li>Delhi</li>
            <li>Mumbai</li>
            <li>Pune</li>
            <li>Bangalore</li>
            <li>Mysore</li>
            <li>Chennai</li>
            <li>Raipur</li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Company</h4>
          <ul>
            <li>Homeshiksha Blog</li>
            <li>About Us</li>
            <li>Contact Us</li>
            <li>Why Homeshiksha</li>
            <li>Our Results</li>
            <li>How it works</li>
            <li>Resource Library</li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Others</h4>
          <ul>
            <li>Abacus Home Tutor</li>
            <li>Online Tutor for GMAT, GRE, IELTS, SAT, CAT entrance</li>
            <li>Need Special Educator or Shadow Teacher</li>
            <li>Home Tutor for CBSE, IB, IGCSE, CAMBRIDGE, STATE Syllabus</li>
            <li>Home Tutor for Foreign language</li>
          </ul>
        </div> */}
      </div>

      <div className="footer-contact">
        <h4>Get In Touch</h4>
        <div className="footer-numbers">
          <p className="footer-numbers-number">+91-9642222147 </p>
          <p className="footer-numbers-number">+91-9133416664</p>
          <p className="footer-numbers-number">
            Email: <a href="mailto:contact@homeshiksha.com">contact@homeshiksha.com</a>
          </p>
        </div>
      </div>

      <div className="footer-terms">
        <div className="footer-social">
          <a href="https://www.facebook.com/HomeShiksha" target="_blank" rel="noopener noreferrer">
            <img src="./facebook-icon.png" alt="Facebook" className="social-icon" />
          </a>
          <a href="https://x.com/homeshiksha" target="_blank" rel="noopener noreferrer">
            <img src="./twitter-icon.png" alt="Twitter" className="social-icon" />
          </a>
          <a href="https://www.linkedin.com/company/home-shiksha/" target="_blank" rel="noopener noreferrer">
            <img src="./linkedin-icon.png" alt="LinkedIn" className="social-icon" />
          </a>
          <a href="https://www.instagram.com/homeshiksha/?hl=en" target="_blank" rel="noopener noreferrer">
            <img src="./instagram-icon.png" alt="Instagram" className="social-icon" />
          </a>
        </div>
        <p className="footer-numbers-number">
          <a href="https://homeshiksha.com/parents-terms-and-conditions/" target="_blank" rel="noopener noreferrer">Parents Terms and Conditions</a>
          {" | "}
          <a href="https://homeshiksha.com/tutors-terms-and-conditions/" target="_blank" rel="noopener noreferrer">Tutors Terms and Conditions</a>
        </p>
        <p className="footer-numbers-number">Copyright &copy; 2026 HomeShiksha. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
